import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import LandingView from "../components/LandingView";

export default function Landing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [c, setC] = useState(null);

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  useEffect(() => {
    api.get("/site-content").then((r) => setC(r.data)).catch(() => {});
  }, []);

  if (!c) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#070707] text-white">
        <div className="h-8 w-8 rounded-full border-2 border-white/20 animate-spin" style={{ borderTopColor: "#FFD60A" }} />
      </div>
    );
  }
  return (
    <div className="min-h-screen">
      <LandingView
        content={c}
        onNavigate={(p) => navigate(p)}
        onChoosePlan={(planId) => { localStorage.setItem("pending_plan_id", planId); navigate("/signup"); }}
        onTopup={(packId) => { localStorage.setItem("pending_topup", packId); navigate("/signup"); }}
      />
    </div>
  );
}
